import { fadeInAnimation } from './../../../../../shared/src/lib/_animations/fade-in.animation';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {
  CountryDto,
  StateDto,
  LgaDto,
  ProjectTypeDto,
  ProjectCategoryDto,
  ClusterDto,
  ClusterCommunityDto,
  OilBlockDto,
  OilFieldDto,
  CommunityDto,
  DocumentCategoryDto,
  DocumentSubCategoryDto,
  GMOUDto,
  ProjectDto,
  CurrencyDto,
} from '@cradua/data';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ProjectReferencesService } from '../../services/project-references.service';
import { MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { ProjectModalComponent } from 'libs/shared/src/lib/components/project-modal/project-modal.component';

@Component({
  selector: 'mrsoftapps-view-projects',
  templateUrl: './view-projects.component.html',
  styleUrls: ['./view-projects.component.scss'],
  //  // make fade in animation available to this component
  animations: [fadeInAnimation],

  //  // attach the fade in animation to the host (root) element of this component
  host: { '[@fadeInAnimation]': '' },
})
export class ViewProjectsComponent implements OnInit {
  @Input() states: StateDto[];
  @Input() lgas: LgaDto[];
  @Input() projectTypes: ProjectTypeDto[];
  @Input() projectCategories: ProjectCategoryDto[];
  @Input() projectData: GMOUDto;
  @Input() oilBlocks: OilBlockDto[];
  @Input() oilFields: OilFieldDto[];
  @Input() communities: CommunityDto[];
  @Input() countries: CountryDto[];
  @Input() clusters: ClusterDto[];
  @Input() clusterCommunity: ClusterCommunityDto[];
  @Input() projectManagements: ProjectDto[];
  @Input() documentCategory: DocumentCategoryDto[];
  @Input() documentSubCategory: DocumentSubCategoryDto[];
  @Input() gmous: GMOUDto[];
  @Input() currencies: CurrencyDto[];
  @Output() changeEmit = new EventEmitter<any>();
  @Output() onActivityEmit = new EventEmitter<any>();
  @Output() taskEmit = new EventEmitter<any>();
  @Output() deleteEvent = new EventEmitter<any>();
  @Output() deleteProjectEvent = new EventEmitter<any>();
  @Output() dispatchEdit = new EventEmitter<any>();
  @Output() viewEvent = new EventEmitter<any>();
  @Output() createProjectEmit = new EventEmitter<any>();
  term = '';
  projectForm: FormGroup;
  selectedGmous: any;
  GmouData: GMOUDto;
  status = false;
  listView = false;
  gridView = true;
  date = new Date();
  users = [
    { id: 1, name: 'Elvis Steve' },
    { id: 2, name: 'Julius Oko' },
  ];
  selectedProjects: ProjectDto[] | any[];
  genericFieldLabel: string;
  genericBlockLabel: string;
  GMOUName: string;
  totalAmount: any;
  selectedGMOUId: string;
  constructor(
    private fb: FormBuilder,
    private projectRefService: ProjectReferencesService,
    public matDialog: MatDialog
  ) {}

  ngOnInit() {
    this.getGmouForm();
  }

  ngAfterViewInit(): void {
    //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    //Add 'implements AfterViewInit' to the class.
    this.filterProjectModal();
  }

  getGmouForm() {
    this.projectForm = this.fb.group({
      GMOUTypeId: ['', Validators.required],
      GMOUCategoryId: [''],
      GMOUId: [''],
      Location: [''],
      Objective: [''],
      Executor: [''],
      StartDate: ['', Validators.required],
      EndDate: ['', Validators.required],
      ProjectTitle: ['', Validators.required],
      Budget: [0, Validators.required],
      BudgetSpent: [0],
      MilestonePayment: [0],
      Milestone: [''],
      Status: ['Pending'],
      OilBlocId: [''],
      OilFieldId: [''],
      StateId: [''],
      LGAId: [''],
      Description: [''],
    });
  }

  onList() {
    this.listView = true;
    this.gridView = false;
  }

  onViewProject(value) {
    this.viewEvent.emit(value);
    // this.taskEmit.emit('activity');
  }

  onDelete(id: string) {
    this.deleteProjectEvent.emit(id);
  }

  onGrid() {
    this.gridView = true;
    this.listView = false;
  }

  filterProjectModal() {
    const dialogConfig = new MatDialogConfig();
    // The user can't close the dialog by clicking outside its body
    dialogConfig.disableClose = false;
    dialogConfig.id = 'modal-component';
    dialogConfig.height = '400px';
    dialogConfig.width = '30%';
    dialogConfig.backdropClass = 'backdropBackground';
    dialogConfig.data = {
      name: 'reportSelectOptions',
      projectCategories: this.projectCategories,
      projectTypes: this.projectTypes,
      gmous: this.gmous,
    };

    const modalDialog = this.matDialog.open(
      ProjectModalComponent,
      dialogConfig
    );
    modalDialog.afterClosed().subscribe((result) => {
      if (result !== undefined) {
        this.selectGMOU(result.gmouId);
      }
    });
  }

  /* Handle form errors in Angular 8 */
  public errorHandling = (control: string, error: string) => {
    return this.projectForm.controls[control].hasError(error);
  };

  selectProjectType(event) {
    this.selectedGmous = this.gmous.filter(
      (item) => item.GMOUTypeId === event.value
    );
  }

  selectGMOU(id: string) {
    this.selectedGMOUId = id;
    const gmoutItem: GMOUDto = this.gmous.find((item) => item.id === id);
    console.log('selected gmou lga ', gmoutItem);
    const foundProject: ProjectDto[] = this.projectManagements.filter(
      (item) => item.GMOUId === gmoutItem.id
    );
    if (foundProject.length > 0) {
      this.GMOUName = gmoutItem.GMOUTitle;
      this.selectedProjects = foundProject.map((value) => {
        return {
          id: value.id,
          ProjectTitle: value.ProjectTitle,
          Description: value.Description,
          GMOUCategory: this.projectRefService.projectCategoryName(
            this.projectCategories,
            value.GMOUCategoryId
          ),
          GMOUCategoryId: value.GMOUCategoryId,
          GMOUType: this.projectRefService.projectTypeName(
            this.projectTypes,
            value.GMOUTypeId
          ),
          GMOUTypeId: value.GMOUTypeId,
          Lgas: this.projectRefService.getLgaArray(this.lgas, value.LGAId),
          LGAId: value.LGAId,
          States: this.projectRefService.getStateArray(
            this.states,
            value.StateId
          ),
          StateId: value.StateId,
          OilBlocks: this.projectRefService.getOilBlockArray(
            this.oilBlocks,
            value.OilBlocId
          ),
          OilBlocId: value.OilBlocId,
          OilFields: this.projectRefService.getOilFieldArray(
            this.oilFields,
            value.OilFieldId
          ),
          OilFieldId: value.OilFieldId,
          Currency: this.projectRefService.currencyName(
            this.currencies,
            value.CurrencyId
          ),
          CurrencyId: value.CurrencyId,
          Budget: value.Budget,
          EndDate: value.EndDate,
          StartDate: value.StartDate,
          Executor: value.Executor,
          GMOUName: this.projectRefService.gmouName(this.gmous, value.GMOUId),
          GMOUId: value.GMOUId,
          projectActivities: value.projectActivities,
          projectHistoryReports: value.projectHistoryReports,
        };
      });

      this.totalAmount = this.selectedProjects
        .map((item) => item.Budget)
        .reduce((prev, next) => prev + next);

      if (this.oilFields.length > 0) {
        this.genericFieldLabel = this.oilFields[0].LabelName;
        this.genericBlockLabel = this.oilBlocks[0].LabelName;
      }
      this.status = true;
    } else {
      this.onCreateProject();
    }
  }

  getState(id) {
    const selectedLga = this.lgas.find((item) => item.id === id);

    if (!selectedLga) {
      return;
    }

    const selectedState = this.states.find(
      (item) => item.id === selectedLga.StateId
    );

    if (!selectedState) {
      return;
    }

    return selectedState;
  }

  onCreateProject() {
    this.createProjectEmit.emit(this.selectedGMOUId);
  }

  days_between(date1, date2) {
    // The number of milliseconds in all UTC days (no DST)
    const oneDay = 1000 * 60 * 60 * 24;
    const StartDate = new Date();
    const EndDate = new Date(date2);
    // A day in UTC always lasts 24 hours (unlike in other time formats)
    const start = Date.UTC(
      EndDate.getFullYear(),
      EndDate.getMonth(),
      EndDate.getDate()
    );
    const end = Date.UTC(
      StartDate.getFullYear(),
      StartDate.getMonth(),
      StartDate.getDate()
    );

    // so it's safe to divide by 24 hours
    return (start - end) / oneDay;
  }

  getProjectCategory(id) {
    const selectedType = this.projectTypes.find((item) => item.id === id);
    if (!selectedType) {
      return;
    }

    const selectedCategory = this.projectCategories.find(
      (item) => item.id === selectedType.ProjectCategoryId
    );

    if (!selectedCategory) {
      return;
    }

    return selectedCategory;
  }

  getOilBlock(id) {
    const selectedOilField = this.oilFields.find((item) => item.id === id);
    if (!selectedOilField) {
      return;
    }

    const selectedOilBlock = this.oilBlocks.find(
      (item) => item.id === selectedOilField.OilBlockId
    );

    if (!selectedOilBlock) {
      return;
    }

    return selectedOilBlock;
  }

  onEdit(value) {
    this.dispatchEdit.emit(value);
  }
}
